"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const standard_1 = require("react-hook-schema/standard");
const TranslateAllModal_1 = require("../TranslateAllModal");
const components_1 = require("utils/components");
function TranslateAllButton({ children, confirmTitle: title, confirmContent: content, langId, projectId, segmentId, scripts, }) {
    const [show, setShow] = react_1.default.useState(false);
    const alert = (0, standard_1.useAlert)();
    const translateModal = (0, TranslateAllModal_1.useTranslateModal)();
    const handleTranslateAll = (0, react_1.useCallback)((scripts) => __awaiter(this, void 0, void 0, function* () {
        if (!langId) {
            alert({ message: "最初に言語を選択してください" });
        }
        if (langId) {
            yield translateModal({
                projectId,
                segmentId,
                langId,
                scripts,
                closeModal: () => {
                    return;
                },
            });
        }
    }), [langId, translateModal]);
    const handleConfirm = (0, react_1.useCallback)(() => {
        setShow(false);
        handleTranslateAll(scripts);
    }, [handleTranslateAll, scripts, setShow]);
    const handleCancel = (0, react_1.useCallback)(() => {
        setShow(false);
    }, [setShow]);
    // Use the shared hook for keyboard shortcuts
    (0, standard_1.useKeyboardShortcuts)(handleConfirm, handleCancel, show);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Button, { size: "base", onClick: () => setShow(true), style: { minWidth: "90px" } }, children),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: show },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, title)),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement("span", null, content)),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(components_1.Button, { variant: "outline-primary", onClick: handleCancel }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                react_1.default.createElement(components_1.Button, { onClick: handleConfirm }, "OK")))));
}
exports.default = TranslateAllButton;
